import './SectionTitle.css';

export default function SectionTitle({ title, subtitle, align = 'center', light = false }) {
  return (
    <div className={`st${align === 'left' ? ' st--left' : ''}${light ? ' st--light' : ''}`}>
      <h2 className="st__heading">{title}</h2>
      {subtitle && <p className="st__sub">{subtitle}</p>}
      <span className="st__line" />
    </div>
  );
}
